// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"125":"72196ac30b62669f","280":"c26af96d9d5ee2c8","578":"fb5691beb888efa3","791":"09446d589a06ef30"}[chunkId] + ".css";
};